import React from 'react';
import { AppLogo } from '../Icons';
import Text from '../Text';
import './Header.css';

const Header = ({ page, hidden }) => (
    <header className={`app-header ${hidden ? 'app-header--hidden' : ''}`}>
        <span className="app-header__logo">
            <AppLogo />
        </span>
        <Text className="app-header__page">
            {page}
        </Text>
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/header/Header.js